module.exports = __webpack_public_path__ + "img/link-handbook-mobile_en.88de82e.jpg";